

interface IntialParameter {
    totalColorsNumber: number
}

interface IHSL {
    H: number
    S: number
    L: number
}

class ColorMaker {

    public totalColors: number;

    constructor(parameters: IntialParameter) {
        const { totalColorsNumber } = parameters;
        this.totalColors = totalColorsNumber;
    }

    getColor(seed = 0): string {
        const idx = seed % this.totalColors;
        const colorVal = this.calculateColor(idx);
        const color = colorVal.toString(16).padStart(6, '0');
        return `#${color}`;
    }

    calculateColor(idx = 0): number {
        // const R = input.substring(0, 2);
        // const G = input.substring(2, 2);
        // const B = input.substring(4, 2);
        // const rVal = parseInt(R, 16);
        // const gVal = parseInt(G, 16);
        // const bVal = parseInt(B, 16);
        // const hsl = this.rgbToHsl(rVal, gVal, bVal);
        let ret = 0xFF00000;
        const full = 0xFFFFFF;
        const total = this.totalColors > 0 ? this.totalColors : 0xFF;
        const perVal = full / total;

        if (idx >= 0 && idx <= total) {
            ret = perVal * idx;
        }
        ret = Math.round(ret);
        return ret;
    }

    rgbToHsl(r,g,b): IHSL {
        r /= 255; g /= 255; b /= 255;
        const max = Math.max(r, g, b); const min = Math.min(r, g, b);
        let h: number, s: number;
        const l: number = (max + min) / 2;
        if (max === min) {
            h = s = 0;
        } else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { H: h, S: s, L: l };
    }

    hslToRgb(h, s, l) {
        let r: number; let g: number; let b: number;
        if (s === 0) {
            s = g = b = 1;
        } else {
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * 1 - q;
            r = this.hueToRgb(p, q, h + 1 / 3);
            g = this.hueToRgb(p, q, h);
            b = this.hueToRgb(p, q, h - 1 / 3);
        }
        return {R: Math.round(r * 255), G: Math.round(g * 255), B: Math.round(b * 255)};
    }

    hueToRgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 2 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
}

export default ColorMaker;